// eslint-disable-next-line no-restricted-imports
import { W8BenFormFragment } from 'api/generated/graphql';
import { W8BenFormEntity } from 'api/types/entity';
import { lodash } from 'helpers';

import { parseFileDocumentEntity } from '../client/parseEntity/parseFileEntity';

export const parseW8BENFormEntity = (
  w8BenForm: Omit<W8BenFormFragment, '__typename'>
): W8BenFormEntity => ({
  files: lodash.compact(w8BenForm.documents).map(parseFileDocumentEntity),
  isUSSecuritiesInvestmentPlanned: w8BenForm.isUSSecuritiesInvestmentPlanned,
});
